import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface ICustomerItemState {
  activeStep: number;  
  isAllowCreateOrder: boolean;
}

const initialState: ICustomerItemState = {
  activeStep: 1,  
  isAllowCreateOrder: false,
};

export const customerItemSlice = createSlice({
  name: 'customerItem',
  initialState,
  reducers: {
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    setIsAllowCreateOrder: (state, action: PayloadAction<boolean>) => {
      state.isAllowCreateOrder = action.payload;
    },
  }  
});

export const selectCustomerItemActiveStep = (state: RootState) => state.customerItem.activeStep;
export const selectCustomerItemIsAllowCreateOrder = (state: RootState) => state.customerItem.isAllowCreateOrder;

export const {
  setActiveStep,
  setIsAllowCreateOrder,
} = customerItemSlice.actions;

export default customerItemSlice.reducer;
